import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const MACHINETYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.MachineType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.MachineType.Code')
    .required()
    .minLength(2)
    .maxLength(10)
    .build(),
];

export const MACHINETYPE_CONFIG = {
  entityName: 'MachineType',
  localizationKey: 'General::Entity.MachineType',
  fields: MACHINETYPE_FIELDS,
  permission: 'ControllingStructural.MachineTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Structural + MENU_NAME_SUFFIX,
};
